import {observer} from "mobx-react";
import React from "react";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import ButtonExpandOnHover from "@dropDesk/presentation/components/buttons/button_expand_on_hover";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {Tooltip} from "antd";
import {SharedColors} from "@dropDesk/domain/entities/theme/app_colors";

const ButtonNewExpanded = observer(
    ({
         onClick,
         loading,
         tooltip,
     }: {
        onClick: () => void
        loading: boolean
        tooltip?: string;
    }) => {

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        return (
            <Tooltip title={tooltip}>
                <ButtonExpandOnHover
                    loading={loading}
                    onClick={onClick}
                    style={{marginRight: '10px'}}
                    label={'Novo'}
                    icon={ICONS_DROPDESK.add}
                    sizeIcon={18}
                    radius={10}
                    backgroundColor={colors.accent}
                    textColor={SharedColors.white}
                    size={40}
                />
            </Tooltip>
        )
    })
export default ButtonNewExpanded;
